import { cs } from './cs';
import { uk } from './uk';
import { ru } from './ru';
import { en } from './en';

/** Kódy jazyků podle BCP 47. Prototyp používal `cz`/`ua`, což nejsou platné kódy. */
export type Lang = 'cs' | 'uk' | 'ru' | 'en';

export const LANGS: Lang[] = ['cs', 'uk', 'ru', 'en'];

/** Zkratky v segmentovaném ovladači – čitelné bez znalosti kterékoli z těch řečí. */
export const LANG_LABEL: Record<Lang, string> = {
  cs: 'CZ',
  uk: 'UA',
  ru: 'RU',
  en: 'EN',
};

export type TKey = keyof typeof cs;

export type Dictionary = Record<TKey, string>;

export const DICTIONARIES: Record<Lang, Dictionary> = { cs, uk, ru, en };
